import { api } from '../../libs/api'
import dateToDateString from '../../libs/date-to-date-string'
import {
  aggSalaryTypes,
  aggTypes,
  aggVerticalAxis,
  aggrangeTypes,
} from '../../constants'


export default {
  namespaced: true,

  state: {
    index: [],
    errors: [],
    condition: {},
    modal: {
      showAggJobSearchConditionModal: false,
    },
  },
  getters: {
    humanizedIndex: (state, _a, _b, rootGetters) =>
      state.index.map(({ id, name, condition, updated_at: updatedAt }) => {
        const {
          mediaCd,
          prefectureCd,
          cityCd,
          workPlacePrefectureCd,
          workPlaceCityCd,
          industryCd,
          salaryCd,
          aggType,
          verticalAxis,
          rangeType,
          employmentCd,
          jobtypeCd,
        } = condition

        // 給与
        const salaryType = aggSalaryTypes.find(({ code }) => code === salaryCd)
        const salaryTypeName = salaryType ? salaryType.name : '全て'

        return {
          id,
          name,
          media: rootGetters['master/translateList']('media', mediaCd),
          prefectures: rootGetters['master/translateList']('prefectures', prefectureCd),
          cities: rootGetters['master/translateList']('cities', cityCd),
          workPlacePrefectures: rootGetters['master/translateList']('prefectures', workPlacePrefectureCd),
          workPlaceCities: rootGetters['master/translateList']('cities', workPlaceCityCd),
          industries: rootGetters['master/translateList']('industries', industryCd),
          salaryTypes: salaryTypeName,
          aggType: aggTypes.find(({ code }) => code === aggType).name,
          verticalAxis: aggVerticalAxis.find(({ code }) => code === verticalAxis).name,
          rangeType: aggrangeTypes.find(({ code }) => code === rangeType).name,
          employments: rootGetters['master/translateList']('employments', employmentCd),
          jobtypes: rootGetters['master/translateList']('jobtypes', jobtypeCd),
          condition,
          updatedAt: dateToDateString(new Date(updatedAt)),
        }
      }),
    condition: state => state.condition,
    sending: state => state.modal.showAggJobSearchConditionModal,
    list: state => state.index.map(({ id, name }) => ({ id, name })),
  },
  mutations: {
    index: (state, index) => state.index = index,
    errors: (state, errors) => state.errors = errors,
    condition: (state, condition) => state.condition = condition,
    showAggJobSearchConditionModal: state => state.modal.showAggJobSearchConditionModal = true,
    hideAggJobSearchConditionModal: state => state.modal.showAggJobSearchConditionModal = false,
  },
  actions: {
    async fetchIndex ({ commit }) {
      try {
        commit('index', await api.fetchMyAggJobSearchConditionIndex())
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async setConditions ({ commit }, { condition }) {
      commit('condition', condition)
    },
    async send ({ commit }, { name, condition, id }) {
      try {
        if (id) {
          await api.updateAggJobSearchCondition({
            id,
            name,
            condition,
          })
        } else {
          await api.createAggJobSearchCondition({
            name,
            condition,
          })
        }
      } catch (e) {
        commit('errors', e)
        return Promise.reject(e)
      }
    },
    async destroy ({ dispatch }, { id }) {
      try {
        await api.destroyAggJobMySearchCondition({ id })
        await dispatch('fetchIndex')
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/aggJobSearchCondition.js